import React, { FC } from 'react'
import { FormikHelpers } from 'formik'

import { FormErrorsProps } from '../../form/FormErrors'
import { FormikFormProps } from '../../form/FormikForm'
import { FormTextProps } from '../../form/FormText'
import { FormCheckboxProps } from '../../form/FormCheckbox'
import FormikField from '../../form/FormikField'
import { ActionButtonProps } from '../../ActionButton'
import { Icons } from '../../Icon/types'
import Icon from '../../Icon'

import * as SC from './styled'

export type RegisterFormValues = {
  firstName: string
  lastName: string
  email: string
  attendant?: {
    firstName: string
    lastName: string
    email: string
  }
  terms: boolean
  opt: boolean
}

export type RegisterFormProps = {
  className?: string
  formik: FormikFormProps<RegisterFormValues>
  fields: {
    firstName: FormTextProps
    lastName: FormTextProps
    email: FormTextProps
    attendant?: {
      firstName: FormTextProps
      lastName: FormTextProps
      email: FormTextProps
    }
    terms: FormCheckboxProps
    opt?: FormCheckboxProps
  }
  attendant?: {
    title: string
    onDelete: () => void
    button?: ActionButtonProps
  }
  errors?: FormErrorsProps['errors']
  onSubmit?: (values: RegisterFormValues, formikHelpers: FormikHelpers<RegisterFormValues>) => void
}

const RegisterForm: FC<RegisterFormProps> = ({ className, formik, fields, attendant, errors }) => {
  return (
    <SC.Form className={className} {...formik}>
      <SC.FormFields>
        <SC.FormFieldsName>
          <FormikField {...fields.firstName} Component={SC.FieldFormText} />
          <FormikField {...fields.lastName} Component={SC.FieldFormText} />
        </SC.FormFieldsName>
        <FormikField {...fields.email} Component={SC.FieldFormText} />

        {fields.attendant && (
          <SC.FormFieldsAttendant>
            <SC.AttendantHeading>
              <SC.Title>{attendant?.title}</SC.Title>
              <SC.RemoveButton type="button" onClick={attendant?.onDelete}>
                <Icon icon={Icons.close} color="black" />
              </SC.RemoveButton>
            </SC.AttendantHeading>
            <SC.FormFieldsName>
              <FormikField {...fields.attendant.firstName} Component={SC.FieldFormText} />
              <FormikField {...fields.attendant.lastName} Component={SC.FieldFormText} />
            </SC.FormFieldsName>
            <FormikField {...fields.attendant.email} Component={SC.FieldFormText} />
          </SC.FormFieldsAttendant>
        )}

        <FormikField {...fields.terms} type="checkbox" Component={SC.FieldFormCheckbox} />
        {fields.opt && (
          <FormikField {...fields.opt} type="checkbox" Component={SC.FieldFormCheckbox} />
        )}

        {!fields.attendant && attendant?.button && (
          <SC.Button variant="secondary" {...attendant.button} icon={Icons.plus} iconSide="left" />
        )}
      </SC.FormFields>
      {errors && <SC.Errors errors={errors} />}
    </SC.Form>
  )
}

export default RegisterForm
